import { supabase } from "../lib/supabase";

export const FOLLOWUP_STATUSES = [
  { value: "not_contacted", label: "Not contacted" },
  { value: "contacted", label: "Contacted" },
  { value: "will_complete_later", label: "Will complete later" },
  { value: "not_interested", label: "Not interested" },
];

export const followupLabel = (v) => FOLLOWUP_STATUSES.find((s) => s.value === v)?.label || v;
export const followupBadge = (v) => ({
  not_contacted: "bg-stone-100 text-stone-600",
  contacted: "bg-emerald-50 text-emerald-800",
  will_complete_later: "bg-[#F5E6BA] text-[#7A0016]",
  not_interested: "bg-red-50 text-red-800",
}[v] || "bg-stone-100 text-stone-600");

const safe = (v) => String(v).replace(/[,()*%\\:"]/g, " ").trim();

export const emptyDraftFilters = { q: "", step: "", from: "", to: "", profileFor: "", followUp: "" };

export function applyDraftFilters(query, f) {
  let q = query;
  const term = f.q ? safe(f.q) : "";
  if (term) q = q.or(`full_name.ilike.*${term}*,email.ilike.*${term}*,applicant_mobile.ilike.*${term}*,present_phone.ilike.*${term}*,present_whatsapp.ilike.*${term}*`);
  if (f.step) q = q.eq("current_step", Number(f.step));
  if (f.from) q = q.gte("signed_up_at", `${f.from}T00:00:00+05:30`);
  if (f.to) q = q.lte("signed_up_at", `${f.to}T23:59:59+05:30`);
  if (f.profileFor) q = q.eq("profile_for", f.profileFor);
  if (f.followUp) q = q.eq("follow_up_status", f.followUp);
  return q;
}

export async function fetchDrafts({ filters, sort, page, pageSize }) {
  let q = supabase.from("incomplete_registrations").select("*", { count: "exact" });
  q = applyDraftFilters(q, filters).order(sort.key, { ascending: sort.dir === "asc" });
  const from = (page - 1) * pageSize;
  const { data, error, count } = await q.range(from, from + pageSize - 1);
  if (error) throw error;
  return { rows: data, count: count || 0 };
}

export async function fetchAllDrafts(filters, sort) {
  let q = supabase.from("incomplete_registrations").select("*");
  q = applyDraftFilters(q, filters).order(sort.key, { ascending: sort.dir === "asc" }).limit(5000);
  const { data, error } = await q;
  if (error) throw error;
  return data;
}

export const setDraftFollowup = (userId, status, note) =>
  supabase.rpc("set_draft_followup", { p_user_id: userId, p_status: status, p_note: note || null }).then(({ error }) => {
    if (error) throw error;
  });

export const DRAFT_EXPORT_COLUMNS = [
  { key: "full_name", label: "Name" },
  { key: "email", label: "Email" },
  { key: "signup_method", label: "Signup method" },
  { key: "applicant_mobile", label: "Applicant mobile" },
  { key: "present_phone", label: "Phone" },
  { key: "present_whatsapp", label: "WhatsApp" },
  { key: "profile_for", label: "Bride/Groom" },
  { key: "step", label: "Last step", value: (r) => `Step ${r.current_step} of 8` },
  { key: "pct", label: "% complete", value: (r) => `${Math.round((r.current_step / 8) * 100)}%` },
  { key: "follow_up_status", label: "Follow-up", value: (r) => followupLabel(r.follow_up_status) },
  { key: "signed_up_at", label: "Signed up", value: (r) => (r.signed_up_at ? new Date(r.signed_up_at).toLocaleDateString("en-IN") : "") },
  { key: "last_activity_at", label: "Last activity", value: (r) => (r.last_activity_at ? new Date(r.last_activity_at).toLocaleDateString("en-IN") : "") },
];
